import { render, staticRenderFns } from "./ContentAdded.vue?vue&type=template&id=1bf6e5bb&scoped=true"
import script from "./ContentAdded.vue?vue&type=script&lang=js"
export * from "./ContentAdded.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf6e5bb",
  null
  
)

export default component.exports